export enum EventParticipantStatusEnum {
  Unanswered = 0, // Obesvarad
  Attending = 10, // Anmäld
  NotAttending = 20, // Kommer inte
  Cancelled = 30, // Avbokad
}
